import { isEmpty, toString } from 'lodash';

export const utils = {
  checkValueIfNotReturnHyphen(value) {
    if (isEmpty(toString(value))) {
      return '-';
    }
    return value;
  }
};

export const checkAdmin = () => {
  const role = localStorage.getItem('role');
  const isInternal = localStorage.getItem('is_Internal');
  return role === 'ADMIN' && isInternal;
};

export const checkManager = () => {
  const role = localStorage.getItem('role');
  return role === 'MANAGER';
};

export const togglePswd = (eve, id) => {
  let pswdInput = document.getElementById(id);
  const spanId = eve && eve.target && eve.target.id;
  let spanCls = document.getElementById(spanId);
  if (pswdInput.type === 'password') {
    pswdInput.type = 'text';
    spanCls.className = 'fa fa-eye fa-eye-slash pswd-toggle';
  } else {
    pswdInput.type = 'password';
    spanCls.className = 'fa fa-fw fa-eye pswd-toggle';
  }
};
